import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--px-5);
	.send-link-request { 
		padding: 0 !important;
		display: flex;
		gap: var(--px-8);
		align-items: center;
	}
	${(props) =>
		props.disabled &&
		`
        .motif-text-alt-button.motif-text-alt-button:disabled {
            cursor: unset;
        }
    `}
`;
